import { render, staticRenderFns } from "./tiscInput.vue?vue&type=template&id=2af9a860&"
import script from "./tiscInput.vue?vue&type=script&lang=js&"
export * from "./tiscInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports